export default __webpack_public_path__ + "static/media/foot5.ec99da7d.jpg";